export const getApiDomain = (domain: string, protocol = 'https:') =>
  `${protocol}//api.${domain}`;

export const getNetworkApiDomain = (
  domain: string,
  network: string,
  protocol = 'https:',
) => `${protocol}//${network}.api.${domain}`;
